import { createFileRoute } from "@tanstack/react-router";

import ManageZones from "@/components/ManageZones";

export const Route = createFileRoute("/gym/$venueUuid/settings/sectors")({
  component: () => <ManageZones climbType="SPORT" />,
  beforeLoad: () => {
    return {
      // Not all gyms have sectors, so just redirect to main settings page
      switchVenueLinkOpts: {
        path: "/gym/$venueUuid/settings",
      },
    };
  },
});
